import React from 'react';
import './ArticleDetailsModal.css';

interface Article {
  id: number;
  code: string;
  nom: string;
  description?: string;
  seuil_a?: number;
  seuil_b?: number;
  unite: string;
}

interface ArticleDetailsModalProps {
  article: Article;
  onClose: () => void;
}

const ArticleDetailsModal: React.FC<ArticleDetailsModalProps> = ({
  article,
  onClose,
}) => {
  return (
    <div className="article-modal-backdrop" onClick={onClose}>
      <div
        className="article-modal-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="article-modal-header">
          <h2 className="article-modal-title">{article.nom}</h2>
          <button className="article-modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="article-modal-body">
          {/* Informations générales */}
          <div className="article-modal-info-grid">
            <div className="article-modal-info-item">
              <span className="article-modal-info-label">Réf</span>
              <span className="article-modal-info-value">{article.code}</span>
            </div>
            <div className="article-modal-info-item">
              <span className="article-modal-info-label">Unité</span>
              <span className="article-modal-info-value">{article.unite}</span>
            </div>
          </div>

          {/* Description */}
          <div className="article-modal-section">
            <h3 className="article-modal-section-title">Description</h3>
            {article.description ? (
              <p className="article-modal-description">{article.description}</p>
            ) : (
              <p className="article-modal-empty">Aucune description disponible.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleDetailsModal;
